import { DuttiDatePrimitive } from '../../../domain/models/dates.models';

import { fixDateString } from './fix-date-string.use-case';

/**
 * Dada una fecha, devuelve su string formateado
 *
 * TODO ECOMDUTI-20965 [SSR][Fase 2]: resolver dependencia con navigator
 */

// biome-ignore lint/suspicious/noShadowRestrictedNames: <explanation>
export function toLocaleString(
    date: DuttiDatePrimitive,
    locales: string[] | string = navigator.language,
    options?: Intl.DateTimeFormatOptions
): string {
    return new Date(fixDateString(date)).toLocaleDateString(
        locales,
        options || {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        }
    );
}
